export const defaultMomentFormat = "MMM Do YY, h:mma";

export const shortHumanDateFormat = "DD/MM/YYYY";
export const humanDateFormat = "DD MMMM YYYY";
export const humanDateTimeFormat = "DD MMMM YYYY, h:mma";
export const humanDateTimeFormatCompact = "DD MMM YYYY, h:mma";

// used to group fulfillments by dueAt time - chose a number parsable format to allow calculations
export const actionFulfillmentDueAtFormat = "HHmm";
export const humanActionFulfillmentDueAtFormat = "hh:mmA";

export const activeTimeContextDateFormat = "YYYY-MM-DD";

// used for messaging/chat feature
export const messagingTimeFormat = "hh:mma";
export const messagingDateGroupFormat = humanDateFormat;
